import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './OrderSuccess.css';

const OrderSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    if (location.state && location.state.orderData) {
      setOrderData(location.state.orderData);
    } else {
      navigate('/');
    }
  }, [location, navigate]);

  if (!orderData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="order-success-container">
      <div className="order-success-wrapper">
        <div className="success-animation">
          <div className="checkmark-circle">
            <div className="checkmark"></div>
          </div>
        </div>

        <h1 className="success-title">🎉 Order Placed Successfully!</h1>
        <p className="success-subtitle">
          Thank you for your purchase. Your order has been confirmed.
        </p>

        <div className="order-info-card">
          <div className="order-header">
            <h2>Order Details</h2>
            <span className="order-id">#{orderData.orderId}</span>
          </div>

          <div className="order-info-grid">
            <div className="info-item">
              <span className="info-label">Order Date</span>
              <span className="info-value">
                {new Date(orderData.orderDate).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </span>
            </div>

            <div className="info-item">
              <span className="info-label">Total Items</span>
              <span className="info-value">{orderData.totalItems}</span>
            </div>

            <div className="info-item">
              <span className="info-label">Payment Method</span>
              <span className="info-value">{orderData.paymentMethod}</span>
            </div>

            <div className="info-item">
              <span className="info-label">Total Amount</span>
              <span className="info-value total-amount">${orderData.totalAmount}</span>
            </div>
          </div>

          <div className="shipping-info">
            <h3>📦 Shipping To:</h3>
            <p>{orderData.shippingDetails.fullName}</p>
            <p>{orderData.shippingDetails.address}</p>
            <p>{orderData.shippingDetails.city}, {orderData.shippingDetails.state} - {orderData.shippingDetails.pincode}</p>
            <p>📧 {orderData.shippingDetails.email}</p>
            <p>📞 {orderData.shippingDetails.phone}</p>
          </div>

          <div className="ordered-items">
            <h3>🛍️ Ordered Items:</h3>
            {orderData.items.map((item, index) => (
              <div key={index} className="ordered-item">
                <span>{item.name} × {item.quantity}</span>
                <span>${(item.price * item.quantity).toFixed(2)}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="success-actions">
          <button className="view-orders-btn" onClick={() => navigate('/order-history')}>
            📋 View All Orders
          </button>
          <button className="continue-shopping-btn" onClick={() => navigate('/')}>
            🛒 Continue Shopping
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
